import React, { useState, useEffect } from 'react';
import './App.css';
import { Footer, Header, Main, Skills } from './components';

function App() {
  const [ loading, setLoading ] = useState(true);

  useEffect(() => {
    render();
  }, [loading]);

  const render = () => {
    setTimeout(() => {
      setLoading(false);
    }, 300);
  } 

  if (loading) {
    return (
      <div className="loader">
        Loading...
      </div>
    )
  }

  return (
      <div className="container">
        <Header/>
        <Main/>
        <Skills/>
        <Footer/> 
      </div>
  );
}



export default App;
